import { ChatProps } from "./types";
import { ChatMessages } from "./ChatMessages";
import { ChatTextArea } from "./ChatTextArea";
import { ChatHeader } from "./ChatHeader";

export function Chat({
  messages,
  isLoading,
  onSendMessage,
  onClearChat,
  placeholder,
  disabled
}: ChatProps) {
  return (
    <div className="flex flex-col h-full bg-white overflow-hidden">
      <ChatHeader onNewChat={onClearChat} />
      <ChatMessages messages={messages} isLoading={isLoading} />
      <ChatTextArea 
        onSendMessage={onSendMessage} 
        isLoading={isLoading} 
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
}
